import * as _ from "lodash";
import * as log from "loglevel";

import { action, autorun, computed, observable, runInAction } from "mobx";
import { Agent } from "../services/agent";
import { QueryString } from "../services/query";
import { Audit } from "./models/audit";

export class AuditStore {
	@observable loading = false;
	@observable audits: Audit[] = [];
	@observable auditCount: number;

	constructor(){
	}

	@action async loadAudits(query: QueryString){
		this.loading = true;
		let auditData = await Agent.Audits.get(query);

		runInAction(() => {
			this.audits = auditData.audits.map((data) => {
				return new Audit(data);
			});
			this.auditCount = auditData.count;
			this.loading = false;
		});
	}
}



// WEBPACK FOOTER //
// ./src/stores/audit-store.ts